import React, { createContext } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import { store } from "./store/store";
import { adminStore } from "./store/adminStore";
import { uploadStore } from "./store/uploadStore";
import { uiStore } from "./store/UiStore";
import { inplantsStore } from "./features/inplants/store/inplantsStore";
import { stationOwnerStore } from "./store/stationOwnerStore";
import CustomToastContainer from "./components/forms/notification/CustomToastContainer";

interface State {
  store: typeof store;
  adminStore: typeof adminStore;
  uploadStore: typeof uploadStore;
  uiStore: typeof uiStore;
  inplantsStore: typeof inplantsStore;
  stationOwnerStore: typeof stationOwnerStore;
}

export const Context = createContext<State>({
  store,
  adminStore,
  uploadStore,
  uiStore,
  inplantsStore,
  stationOwnerStore,
});

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");

const root = ReactDOM.createRoot(rootElement);

root.render(
  <Context.Provider
    value={{
      store,
      adminStore,
      uploadStore,
      uiStore,
      inplantsStore,
      stationOwnerStore,
    }}
  >
    {process.env.NODE_ENV === "development" ? (
      <React.StrictMode>
        <>
          <App />
          <CustomToastContainer />
        </>
      </React.StrictMode>
    ) : (
      <>
        <App />
        <CustomToastContainer />
      </>
    )}
  </Context.Provider>,
);
